import type { SVGProps } from "react";
import * as Icons from "@/components/ui/atoms/icons";

/**
 * Brand-asset metadata for MCP clients — label + icon component.
 *
 * Used by:
 *   - `GatewayDiagram` (templates) to render client tiles by id.
 *   - `@arcadeai/ui-kit/mcp-gateway-connect` to compose its richer
 *     MCP_CLIENTS registry (which adds auth types, config builders, deep
 *     links, etc.) — the brand metadata is canonicalised here so it can't
 *     drift across consumers.
 *
 * To add a new MCP client, add an entry here AND make sure the icon is
 * exported from `@/components/ui/atoms/icons`.
 */
export const MCP_CLIENT_METADATA = {
  cursor: { label: "Cursor", Icon: Icons.Cursor },
  vscode: { label: "VS Code", Icon: Icons.Vscode },
  claude_code: { label: "Claude Code", Icon: Icons.Claude },
  claude_desktop: { label: "Claude Desktop", Icon: Icons.Claude },
  goose: { label: "Goose", Icon: Icons.Goose },
  windsurf: { label: "Windsurf", Icon: Icons.Windsurf },
  cline: { label: "Cline", Icon: Icons.Cline },
  codex: { label: "Codex", Icon: Icons.Openai },
  chatgpt: { label: "ChatGPT", Icon: Icons.Openai },
  mcp_url: { label: "MCP URL", Icon: Icons.Mcp },
} as const satisfies Record<
  string,
  {
    label: string;
    Icon: (props: SVGProps<SVGSVGElement>) => React.JSX.Element;
  }
>;

export type McpClientId = keyof typeof MCP_CLIENT_METADATA;
